import { render, staticRenderFns } from "./AssignWeightPopup.vue?vue&type=template&id=cd1e5062"
import script from "./AssignWeightPopup.vue?vue&type=script&lang=js"
export * from "./AssignWeightPopup.vue?vue&type=script&lang=js"
import style0 from "./AssignWeightPopup.vue?vue&type=style&index=0&id=cd1e5062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports